<template>
  <div id="contenedor-presupuestos-toolbar">
    <!-- <v-toolbar flat dense>
      <custom-select
        cols="auto"
        v-model="ejercicio"
        label="Ejercicio"
        :items="ejercicios"
        :rules="[mixReglas.requerido]"
        required>
      </custom-select>
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="nuevo">
      </custom-button>
    </v-toolbar> -->
    <v-toolbar flat>
    <div v-if="!$vuetify.breakpoint.xs"
      style="width: 150px" class="mr-2">
      <ejercicio-picker
        v-model="ejercicio"
        class="mr-2">
      </ejercicio-picker>
    </div>
    <v-spacer></v-spacer>
    <v-tooltip
    v-if="mixValidaScopesActions(1)"
    top>
      <template
        v-slot:activator="{ on, attrs }">
        <template v-if="$vuetify.breakpoint.xs">
          <custom-button
            iconText="mdi-plus"
            tipo="agregar"
            onlyIcon
            @click="nuevo"
            v-bind="attrs"
            v-on="on">
          </custom-button>
        </template>
        <template v-else>
          <custom-button
            label="Nuevo"
            iconText="mdi-plus"
            tipo="agregar"
            @click="nuevo"
            v-bind="attrs"
            v-on="on">
          </custom-button>
        </template>
      </template>
      <span>
        Registrar nuevo presupuesto
      </span>
    </v-tooltip>
  </v-toolbar>
  </div>
</template>

<script>
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ToolBarPresupuestos',
  components: {
    EjercicioPicker,
    CustomButton,
  },
  props: {
    value: {
      default() {
        return this.value || null;
      },
    },
  },
  data() {
    return {
      // ejercicios: [],
    };
  },
  // mounted() {
  //   this.setEjercicios();
  // },
  methods: {
    // setEjercicios() {
    //   this.ejercicios = [];
    //   const yr = Number(new Date().toISOString().substr(0, 4));
    //   const min = yr - 10;
    //   const max = yr + 1;
    //   // eslint-disable-next-line no-plusplus
    //   for (let index = max; index >= min; index--) {
    //     this.ejercicios.push(index);
    //   }
    // },
    nuevo() {
      this.$emit('nuevoPresupuesto');
    },
  },
  computed: {
    ejercicio: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style lang="scss">

</style>
